<template>
  <div>
    <div v-if="page">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="page.body" />
    </div>

    <spinner
      v-else-if="loading"
      preset="large"
    />

    <template v-else-if="notFound">
      <div
        class="alert alert-danger"
        role="alert"
      >
        The page you are looking for does not exist.
      </div>
    </template>

    <template v-else-if="error">
      <div
        class="alert alert-danger"
        role="alert"
      >
        An error occurred while trying to load your feed. Please check your
        connection and try again.
      </div>

      <button
        type="button"
        class="btn btn-outline-primary"
        @click="loadPage"
      >
        Try Again
      </button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Flatpage',
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      page: null,
      loading: false,
      error: false,
      notFound: false,
    };
  },
  watch: {
    slug() {
      this.loadPage();
    },
  },
  created() {
    this.loadPage();
  },
  methods: {
    clearPage() {
      this.page = null;
    },
    async loadPage() {
      this.clearPage();
      this.loading = true;

      const url = `flatpages/${this.slug}`;

      const responseData = await this.api({ url, method: 'GET' });

      this.loading = false;

      if (responseData.status === 200) {
        this.page = responseData.body;
      } else if (responseData.status === 404) {
        this.notFound = true;
      } else {
        this.error = true;
      }
    },
  },
};
</script>
